<template>
  <div class="page">
    <header-title title="Work Request BOM Maintenance"></header-title>

    <div class="s-filter-box">
      <a-form layout="inline" :model="search">
        <a-form-item label="Job ID">
          <a-select
            v-model:value="search.jobId"
            style="width: 200px"
            placeholder="Input or Choosing value "
            show-search
            allowClear
            @change="jobIdChange"
          >
            <a-select-option
              v-for="item in jobIdList"
              :key="item"
              :value="item"
            >
              {{ item }}
            </a-select-option>
          </a-select>
        </a-form-item>
        <a-form-item label="Region">
          <a-select
            v-model:value="search.regionCode"
            style="width: 200px"
            :disabled="!search.jobId"
            placeholder="Please select jobid first"
            show-search
            allowClear
          >
            <a-select-option
              v-for="item in regionList"
              :key="item"
              :value="item"
            >
              {{ item }}
            </a-select-option>
          </a-select>
        </a-form-item>

        <a-form-item>
          <a-button type="primary" @click="find">
            <template #icon><SearchOutlined /></template>
            Find
          </a-button>
        </a-form-item>
      </a-form>
    </div>

    <div class="page-body" ref="pageBodyRef">
      <a-table
        :columns="columns"
        :row-key="(record) => record.id"
        :data-source="bodyItems"
        :loading="loading"
        :pagination="false"
        :scroll="{ x: '100%', y: tableYHeight }"
        size="small"
      >
        <template #bodyCell="{ column, record }">
          <template v-if="column.dataIndex === 'isDriven'">
            <check-outlined v-if="record.isDriven" />
          </template>
          <template v-if="column.dataIndex === 'objectId'">
            <span @click="openObjListModal(record)" class="f-link">
              <FileSearchOutlined></FileSearchOutlined>
              {{ record.objectId }}
            </span>
          </template>

          <template v-if="column.dataIndex === 'action'">
            <a-button type="link" size="small" @click="openAddModal(record)">
              <template #icon><diff-outlined /></template>
            </a-button>
            <a-divider type="vertical" />
            <a-button type="link" size="small" @click="openEditModal(record)">
              <template #icon><edit-outlined /></template>
            </a-button>
            <a-divider type="vertical" />

            <a-button type="link" size="small" @click="deleteRow(record.id)">
              <template #icon><delete-outlined /></template>
            </a-button>
          </template>
        </template>
      </a-table>
      <div class="more" v-if="moreDataCanBeLoaded">
        <a-button type="link" @click="moreLoad">
          更多
          <ArrowDownOutlined />
        </a-button>
      </div>
    </div>

    <a-modal
      v-model:visible="dialogShow"
      width="1000px"
      :title="dialogTitle"
      @ok="save"
      @cancel="bomConfirmLoading = false"
      :confirmLoading="bomConfirmLoading"
    >
      <a-form
        :model="ceForm"
        :rules="rules"
        ref="formRef"
        :labelCol="{ span: 7 }"
      >
        <a-row :gutter="24">
          <a-col :span="12" :offset="12" :pull="12">
            <a-form-item label="Region Code">
              <a-input v-model:value="ceForm.regionCode" disabled />
            </a-form-item>
          </a-col>
          <a-col :span="12">
            <a-form-item
              label="Object Type"
              name="objectType"
              :rules="[{ required: true, message: 'Please select!' }]"
            >
              <a-select v-model:value="ceForm.objectType" showSearch>
                <a-select-option
                  :value="item"
                  v-for="item in objectTypes"
                  :key="item"
                >
                  {{ item }}
                </a-select-option>
              </a-select>
            </a-form-item>
          </a-col>
          <a-col :span="12">
            <a-form-item
              label="Object ID"
              name="objectId"
              :rules="[{ required: true, message: 'Please select!' }]"
            >
              <a-select
                v-model:value="ceForm.objectId"
                :disabled="ceForm.id"
                showSearch
              >
                <a-select-option
                  :value="item"
                  v-for="item in objectIds"
                  :key="item"
                >
                  {{ item }}
                </a-select-option>
              </a-select>
            </a-form-item>
          </a-col>
          <a-col :span="12">
            <a-form-item
              label="Source Region"
              name="sourceRegionCode"
              :rules="[{ required: true, message: 'Please select!' }]"
            >
              <a-select v-model:value="ceForm.sourceRegionCode" showSearch>
                <a-select-option
                  :value="item"
                  v-for="item in sourceRegions"
                  :key="item"
                >
                  {{ item }}
                </a-select-option>
              </a-select>
            </a-form-item>
          </a-col>
          <a-col :span="12">
            <a-form-item
              label="Quantity"
              name="objectQty"
              :rules="[{ required: true, message: 'Please Input!' }]"
            >
              <a-input v-model:value="ceForm.objectQty" allowClear></a-input>
            </a-form-item>
          </a-col>

          <a-col :span="12">
            <a-form-item
              label="Source Type"
              :labelCol="{ span: 7 }"
              name="sourceType"
              :rules="[{ required: true, message: 'Please select!' }]"
            >
              <a-select v-model:value="ceForm.sourceType" showSearch>
                <a-select-option
                  :value="item"
                  v-for="item in sourceTypes"
                  :key="item"
                >
                  {{ item }}
                </a-select-option>
              </a-select>
            </a-form-item>
          </a-col>
          <a-col :span="12">
            <a-form-item label="Is Driven" :labelCol="{ span: 7 }">
              <a-switch v-model:checked="ceForm.isDriven" />
            </a-form-item>
          </a-col>
        </a-row>
      </a-form>
    </a-modal>
    <a-modal
      v-model:visible="objectModalVisible"
      width="1000px"
      title="Object Detail"
      :footer="null"
      @cancel="objectModalVisible = false"
      wrap-class-name="has-table-full-modal"
    >
      <a-table
        :columns="objColumns"
        :row-key="(record) => record.id"
        :data-source="objIdItems"
        :pagination="false"
        size="small"
        :scroll="{ x: '100%', y: 300 }"
      ></a-table>
    </a-modal>
  </div>
</template>

<script>
  import HeaderTitle from '@/layout/header-title'

  import request from '@/utils/request'

  import { mapGetters } from 'vuex'

  import { message, Modal } from 'ant-design-vue'
  import {
    SearchOutlined,
    EditOutlined,
    DeleteOutlined,
    CheckOutlined,
    ArrowDownOutlined,
    DiffOutlined,
    FileSearchOutlined,
  } from '@ant-design/icons-vue'
  import { throttle } from '@/utils'
  export default {
    components: {
      HeaderTitle,
      SearchOutlined,
      EditOutlined,
      DeleteOutlined,
      ArrowDownOutlined,
      CheckOutlined,
      DiffOutlined,
      FileSearchOutlined,
    },

    data() {
      return {
        jobIdList: [],
        regionList: [],
        loading: false,
        bomConfirmLoading: false,
        objectTypes: ['KIT', 'LC', 'SUB', 'WIP'],
        sourceTypes: ['Vendor', 'In House'],
        objectIds: [],
        sourceRegions: [],
        pageNumber: 1,
        pageSize: 15,
        moreDataCanBeLoaded: false,
        objectModalVisible: false,
        objIdItems: [],

        dialogShow: false,
        tableYHeight: 300,
        dialogTitle: 'BOM Item Creation',
        addLoading: false,
        search: {},

        ceForm: {
          regionCode: '',
          objectType: 'KIT',
          objectId: '',
          fgName: '',
          isDriven: false,
          sourceRegionCode: 0,
          sourceType: 'Vendor',
        },

        bodyItems: [],

        columns: [
          {
            title: 'No',
            dataIndex: 'no',
            key: 'no',
            customRender({ index }) {
              return index + 1
            },
            width: '5%',
          },
          {
            title: 'Region',
            dataIndex: 'regionCode',
            width: '12%',
            customRender({ text }) {
              const s = text.split('_')
              return s[s.length - 1]
            },
          },
          {
            title: 'Object Type',
            dataIndex: 'objectType',
            width: '13%',
          },
          {
            title: 'Object ID',
            dataIndex: 'objectId',
            width: '15%',
          },
          {
            title: 'Quantity',
            dataIndex: 'objectQty',
            width: '10%',
          },

          {
            title: 'Is Driven',
            dataIndex: 'isDriven',
            width: '10%',
          },

          {
            title: 'Source Region',
            dataIndex: 'sourceRegionCode',
            width: '15%',
          },
          {
            title: 'Source Type',
            dataIndex: 'sourceType',
            width: '15%',
          },

          {
            title: 'Operation',
            dataIndex: 'action',
            key: 'action',
            width: '12%',
            fixed: 'right',
          },
        ],
        objColumns: [
          {
            title: 'Object ID',
            dataIndex: 'objectId',
            width: '20%',
          },
          {
            title: 'Material ID',
            dataIndex: 'materialId',
            width: '20%',
          },
          {
            title: 'Quantity',
            dataIndex: 'quantity',
            width: '20%',
          },
          {
            title: 'Bin Location',
            dataIndex: 'binLocation',
            width: '20%',
          },
          {
            title: 'Bin Sequence',
            dataIndex: 'binSeq',
            width: '20%',
          },
        ],
      }
    },
    computed: {
      ...mapGetters({ netGroupId: 'user/currentNetGroup' }),
    },
    created() {
      this.init()
    },
    mounted() {
      setTimeout(this.setTableScrollH, 2000)
      window.addEventListener('resize', throttle(this.setTableScrollH, 500))
    },
    methods: {
      setTableScrollH() {
        const obj = this.$refs.pageBodyRef
        if (!obj) return
        const wWidth = document.documentElement.clientWidth
        const tableHeader = document.querySelector('.ant-table-header')
        const tHeadHeight = tableHeader ? tableHeader.clientHeight : 44

        this.tableYHeight = obj.clientHeight - tHeadHeight - wWidth * 0.025
      },
      init() {
        this.getJobIds()
        this.getObjectIds()
        this.getSourceRegions()
      },
      async getJobIds() {
        const { body } = await request({
          url: '/api/workRequestBOM/getJobIds',
          method: 'get',
        })
        this.jobIdList = body
      },
      jobIdChange(jobId) {
        this.regionList = []
        if (jobId) {
          this.getRegionCodes(jobId)
        } else {
          this.search.regionCode = ''
        }
      },
      async getRegionCodes(jobId) {
        const { body } = await request({
          url: '/api/workRequestBOM/getregionCodes',
          method: 'get',
          params: {
            jobId,
          },
        })
        this.regionList = body
      },
      async getObjectIds() {
        const { body } = await request({
          url: '/api/workRequestBOM/getMaterialGroupnByMatQrpId',
          method: 'get',
        })
        this.objectIds = body
      },
      async getSourceRegions() {
        const { body } = await request({
          url: '/api/workRequestBOM/getCfgRegion',
          method: 'get',
        })
        this.sourceRegions = body
      },
      async find() {
        const { jobId, regionCode } = this.search
        const rawData = {
          jobId: jobId || null,
          regionCode: regionCode || null,
          pageNo: this.pageNumber,
          pageSize: this.pageSize,
        }
        this.loading = true
        try {
          const { body } = await request({
            url: '/api/workRequestBOM/wrBomByPage',
            method: 'post',
            data: rawData,
          })
          this.bodyItems = body
          this.moreDataCanBeLoaded = body.length === this.pageSize
          this.loading = false
        } catch (e) {
          this.loading = false
        }
      },
      async moreLoad() {
        const { jobId, regionCode } = this.search
        this.pageNumber++
        const rawData = {
          jobId: jobId || null,
          regionCode: regionCode || null,
          pageNo: this.pageNumber,
          pageSize: this.pageSize,
        }
        this.loading = true
        try {
          const { body } = await request({
            url: '/api/workRequestBOM/wrBomByPage',
            method: 'post',
            data: rawData,
          })
          this.bodyItems = [...this.bodyItems, ...body]
          this.moreDataCanBeLoaded = body.length === this.pageSize
          this.loading = false
        } catch (e) {
          this.loading = false
        }
      },
      // 编辑
      async openEditModal(row) {
        this.ceForm = { ...row }
        this.dialogShow = true
      },
      // 新增
      async openAddModal(row) {
        const cRow = { ...row }
        this.ceForm = {
          regionCode: cRow.regionCode,
          jobId: cRow.jobId,
          isDriven: false,
        }

        this.dialogShow = true
      },
      // 删除
      deleteRow(id) {
        const _this = this
        Modal.confirm({
          title: `This BOM item will be deleted. Please confirm.`,
          async onOk() {
            const hide = message.loading('Deleting..', 0)
            try {
              const result = await request({
                url: '/api/workRequestBOM/delWsBom',
                method: 'post',
                data: {
                  id,
                },
              })

              if (result.errCode === '0000') {
                message.success('Deletion succeeded')
                _this.find()
              }

              hide()
            } catch (e) {
              hide()
            }
          },
        })
      },
      // 弹窗保存
      async save() {
        const _this = this
        this.$refs.formRef.validate().then(() => {
          const isEdit = !!_this.ceForm.id
          if (isEdit) {
            _this.editSave()
          } else {
            _this.addSave()
          }
        })
      },
      editSave() {
        const rawData = { ...this.ceForm }
        const _this = this
        const hide = message.loading('Loading..', 0)
        request({
          url: '/api/workRequestBOM/validateDriven',
          method: 'post',
          nonstandard: true,
          data: rawData,
        })
          .then((res) => {
            if (res.errCode !== '0000') {
              message.error({
                content: res.errMsg,
                onClose: () => {
                  _this.updateWsBom()
                },
              })
            } else {
              _this.updateWsBom()
            }
          })
          .finally(() => {
            hide()
          })
      },
      updateWsBom: function () {
        let _this = this
        const rawData = { ...this.ceForm }
        this.bomConfirmLoading = true
        request({
          url: '/api/workRequestBOM/updateWsBom',
          method: 'post',
          data: rawData,
        })
          .then(() => {
            message.success({
              content: 'Save Success!!!',
              onClose: () => {
                _this.find()
                this.dialogShow = false
              },
            })
          })
          .finally(() => {
            this.bomConfirmLoading = false
          })
      },
      addSave() {
        let _this = this
        const rawData = { ...this.ceForm }
        this.bomConfirmLoading = true
        request({
          url: '/api/workRequestBOM/saveWsBom',
          method: 'post',
          data: rawData,
        })
          .then(() => {
            message.success({
              content: 'Save Success!!!',
              onClose: () => {
                _this.find()
                this.dialogShow = false
              },
            })
          })
          .finally(() => {
            this.bomConfirmLoading = false
          })
      },
      openObjListModal(item) {
        var _this = this
        const hide = message.loading('Loading..', 0)
        request({
          url: '/api/workRequestBOM/wrBomByFindMaterial',
          method: 'post',
          data: {
            objectId: item.objectId,
            id: item.id,
          },
        })
          .then((res) => {
            _this.objIdItems = res.body
            this.objectModalVisible = true
          })
          .finally(() => {
            hide()
          })
      },
    },
  }
</script>

<style lang="less" scoped>
  @import '~@/styles/variables.less';

  .page-body {
    height: calc(100vh - 132px);
    overflow: hidden;
  }
  .s-filter-box {
    padding: 10px;
    background: #f2f3f5;
    border-bottom: 1px solid #dbdcdc;
  }
  .more {
    text-align: right;
  }
  .f-link {
    cursor: pointer;
    color: @primary-color;
    text-decoration: underline;
  }
</style>
<style lang="less">
  .has-table-full-modal {
    .ant-modal-body {
      padding: 0;
    }
  }
</style>
